// Operational activity-log action labels (the per-dispute timeline).
export const ACTIVITY_LABEL = {
  assigned: "Assigned",
  unassigned: "Unassigned",
  evidence_generated: "Evidence generated",
  approved: "Approved and submitted",
  rejected: "Rejected"
}

// Timeline event styling: a registry icon + semantic tone per event type, so the Activity
// log reads as a categorized timeline (a coloured marker per event on a connector line)
// rather than a flat list. Keys cover both the synthesized dispute lifecycle (buildDisputeLogs)
// and the real team feed (ACTIVITY_LABEL actions). Tones map to .rd-timeline_item--* colours.
// Kept deliberately monochrome: every step uses one neutral marker so the log reads as a
// single calm sequence, and only the terminal outcomes carry colour (won = green, lost /
// rejected = red). The distinct icons still tell each event apart.
export const TIMELINE_META = {
  created: { icon: "receipt_check", tone: "neutral" },
  received: { icon: "arrow_inbox", tone: "neutral" },
  generated: { icon: "sparkles_soft", tone: "neutral" },
  assigned: { icon: "user_circle", tone: "neutral" },
  submitted: { icon: "send", tone: "neutral" },
  review: { icon: "eye", tone: "neutral" },
  pending: { icon: "clock", tone: "neutral" },
  won: { icon: "circle_check", tone: "success" },
  lost: { icon: "circle_x", tone: "danger" },
  escalated: { icon: "triangle_exclamation", tone: "neutral" },
  unassigned: { icon: "user_circle", tone: "neutral" },
  evidence_generated: { icon: "sparkles_soft", tone: "neutral" },
  approved: { icon: "send", tone: "neutral" },
  rejected: { icon: "circle_x", tone: "danger" }
}

export const TIMELINE_FALLBACK = { icon: "clock", tone: "neutral" }
